import { useTranslation } from 'react-i18next';

export default function ServiceBoxTitle() {
    const { i18n } = useTranslation();

    return (
        <>
            {
                i18n.language === "ar" ? (

                    <div className="row-1 col-12 col-md-2" style={{ maxWidth: "200px" }}>
                        <h3>خدماتنا</h3>
                        <p>تجدون هنا العديد من خدماتنا التي تنتظركم</p>
                    </div>
                ) : (
                    <div className="row-1 col-12 col-md-2" style={{ maxWidth: "200px" }}>
                        <h3>Our Services</h3>
                        <p>Here you will find many of our services waiting for you</p>
                    </div>
                )
            }
        </>
    )
}